import styled from 'styled-components'
import { colors, cyberColors } from '../../../lib/colors'
import { NumberInputStyledProps } from './Interface'
import { FlexDivProps } from '../../configs/interface'

export const NumberInputWrapper = styled.div<NumberInputStyledProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-items: center;
  pointer-events: ${({ autoPlayIsOn }: any) =>
    autoPlayIsOn ? 'none' : 'auto'};
  opacity: ${({ autoPlayIsOn }: any) => (autoPlayIsOn ? '0.5' : '1')};
  padding: ${({ padding }: any) => padding || '6px 10px'};
  margin: ${({ margin }: any) => margin || '0px'};
  width: ${({ width }: any) => (width ? width : '150px')};
  height: ${({ height }: any) => (height ? height : '42px')};
  border-radius: 4px;
  background: ${({ focus }: any) =>
    !focus ? colors.primaryDark : colors.primaryLight};
  transition: all 0.2s;
  border-bottom: 2px solid
    ${({ focus, isError }: any) =>
      isError
        ? cyberColors.red
        : focus
        ? colors.darkGreyBorder
        : colors.greyBorder};
  svg {
    height: 10px;
    position: absolute;
    bottom: 8px;
    cursor: pointer;
    pointer-events: none;
    z-index: ${({ focus }: any) => (focus ? '-1' : '')};
  }
`
export const InputBox = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  /* @media not all and (min-resolution: 0.1dpi) and (-webkit-appearance: none) {
    align-items: center;
  } */
`
export const Title = styled.div<{ color?: any }>`
  cursor: default;
  font-size: 12px;
  background: ${({ color }: any) =>
    color
      ? color === 'blue'
        ? cyberColors.blueGradient
        : cyberColors.redGradient
      : colors.secondary};
  z-index: 1;
  margin-right: 2px;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  clip-path: inset(0.5px 0px 0px 0.5px);
  /* @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    margin-bottom: 4px;
  } */
`
export const Currency = styled.div<{ fontSize?: any }>`
  line-height: 100%;
  font-size: ${({ fontSize }: any) => (fontSize ? fontSize : '20px')};
  display: flex;
  align-items: center;
  color: ${colors.white};
  /* transform: translateY(-4px); */
  /* margin-top: 1px; */
  /* -webkit-margin-top: 1px; */

  @media not all and (min-resolution: 0.1dpi) and (-webkit-appearance: none) {
    margin-top: 3px;
  }
`
export const Input = styled.input<NumberInputStyledProps>`
  cursor: ${({ readOnly }: any) => (readOnly ? 'unset' : 'pointer')};
  font-size: ${({ fontSize }: any) => (fontSize ? fontSize : '20px')};
  font-family: 'light';
  border: none;
  border-radius: 4px;
  color: ${({ color }: any) => color || colors.white};
  position: relative;
  width: 100%;
  /* height: ${({ h }: any) => h || '20px'}; */
  /* transform: ${({ y }: any) =>
    y ? `translateY(${y}px)` : 'translateY(-4px)'}; */
  max-width: ${({ maxWidth }: any) => maxWidth || '90px'};
  text-overflow: ellipsis;
  will-change: transform;
  transform: ${({ focus }: any) =>
    focus && 'scale(0.99) translate3d( 0, 0, 0) perspective(1px)'};
  transition: scale 0.2s;
  backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
  &::placeholder {
    color: ${({ color }: any) => color || colors.white};
  }
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  background: none;
  &:focus {
    cursor: ${({ readOnly }: any) => (readOnly ? 'unset' : 'text')};
    /* transform: ${({ y }: any) =>
      y ? `translateY(${y}px)` : 'translateY(-4px)'}; */
  }
`

export const FlexDiv = styled.div<FlexDivProps>`
  display: flex;
  justify-content: ${({ startNow }: any) =>
    startNow ? 'flex-start' : 'space-between'};
  width: 100%;
  margin-top: ${({ marginTop }: any) => marginTop || ''};
  margin-bottom: ${({ marginBottom }: any) => marginBottom || ''};
  z-index: 99;
  opacity: ${({ startAuto }) => (startAuto ? 0.5 : 1)};
  pointer-events: ${({ startAuto }) => startAuto && 'none'};
  cursor: ${({ startAuto }) => (startAuto ? 'not-allowed' : 'pointer')};
  transition: opacity 0.5s linear;
`
